exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-footer{padding:0 20px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}", "", {"version":3,"sources":["C:/01_cloud/github/vue/bbq/node_modules/element-ui/lib/theme-chalk/C:/01_cloud/github/vue/bbq/node_modules/element-ui/lib/theme-chalk/footer.css"],"names":[],"mappings":"AAAA,WAAW,eAAe,8BAA8B,sBAAsB,oBAAoB,aAAa,CAAC","file":"footer.css","sourcesContent":[".el-footer{padding:0 20px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}"],"sourceRoot":""}]);

// exports
